/**
 * Date Range filter object
 * Only if the primaryDateRangeSelected param is provided, the object is passed a second filtered array of date ranges to populate a comparison date ranges.
 * For example, if the primary selected date range is 'Today', its comparison date range is 'Yesterday'.
 * If primary is 'CurrentWeek', its comparison is 'PreviousWeek'
 * When used with the primaryDateRangeSelected parameter, is currently only being used with filters.dateRange as the dateRangeFilterValues parameter.
*/
const DateRangeFilter = function DateRangeFilter(dateRangeFilterFieldName, dateRangeFilterValues, dateRangePlaceholder, primaryDateRangeSelected) {
  let dateRangeFilterValuesUpdated = dateRangeFilterValues;

  if (primaryDateRangeSelected) {
    dateRangeFilterValuesUpdated = dateRangeFilterValues.filter(dateRangeFilterValue => primaryDateRangeSelected === dateRangeFilterValue.comparison_value);
  }

  return {
    field_name: dateRangeFilterFieldName || 'dateFilters',
    field_value: '', // TODO: Use config values
    rules: [],
    field_type: 'select',
    label: 'Choose as many as you would like from this list.',
    help_text: 'You can select many choices here #4.',
    values: dateRangeFilterValuesUpdated || [],
    is_required: false,
    is_enabled: true,
    visible: true,
    placeholder: dateRangePlaceholder,
    sub_text: null,
  };
};
/**
 * export service to used by different components
 */
export default DateRangeFilter;



// WEBPACK FOOTER //
// ./src/services/DateRangeFilter.js